import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import IssueTypeLabel from '@hydra/routes/crawler/components/IssueTypeLabel';
import List from '@hydra/routes/crawler/components/List';
import VisualLinkIssue from '@hydra/routes/crawler/components/VisualLinkIssue';
import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import { Grid } from '@material-ui/core';
import get from 'lodash/get';

import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import DCUrlLabel from '@hydra/routes/crawler/components/DCUrlLabel';

function IssueVisualizer ({ domain, issue }) {
  const TypesWithIcon = {
    'sitemap-mismatch': {
      icon: 'sitemap'
    },
    'opengraph-mismatch': {
      icon: 'open-graph'
    }
  };

  const urls = issue.canonical_urls.map(issue => new DCUrl(domain, issue));

  return TypesWithIcon[issue.type]
    ? (
      <VisualLinkIssue
        icon={TypesWithIcon[issue.type].icon}
        severity={issue.severity}
        urls={urls}
      />
      )
    : (
      <div>
        <List style={parseSeverity(issue.severity)} items={urls} />
      </div>
      );
}

export class CanonicalIssuesRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;

    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const sourceUrl = new DCUrl(domain, issue.source_url);

    return (
      <Grid container className={classNameProp} alignItems='flex-start'>
        <Grid item {...columnStyles[0]}>
          <IssueTypeLabel severity={issue.severity} type={issue.type} amount={issue.canonical_urls.length} />
        </Grid>
        <Grid item {...columnStyles[1]}>
          <IssueVisualizer domain={domain} issue={issue} />
        </Grid>
        <Grid item {...columnStyles[2]}>
          <DCUrlLabel url={sourceUrl} severity={issue.severity} />
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(CanonicalIssuesRow, {
  issue: graphql`
    fragment CanonicalIssuesRow_issue on CanonicalIssue {
      id
      type
      severity
      canonical_urls
      source_url
    }
  `
});
